


export const Picture = [
    {pic : require('./Pics/angularjs.png'), matched : false , anime : 'fade-up'},
    {pic : require('./Pics/C-++.png'), matched : false, anime : 'fade-down'},
    {pic : require('./Pics/python.png'), matched : false, anime : 'fade-right'},
    {pic : require('./Pics/C-Sharp.png'), matched : false, anime : 'fade-left'},
    {pic : require('./Pics/HTML5-CSS3.png'), matched : false, anime : 'fade-up-right'},
    {pic : require('./Pics/jQurery.gif'), matched : false, anime : 'fade-up-left'},
    {pic : require('./Pics/JS.png'), matched : false, anime : 'fade-down-right'},
    {pic : require('./Pics/Linux.png'), matched : false, anime : 'fade-down-left'},
    {pic : require('./Pics/Php.jpg'), matched : false, anime : 'zoom-in'},
    {pic : require('./Pics/REACT-JS.png'), matched : false, anime : 'zoom-in-up'},
]



